var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import avatar from "./assets/avatar-icon.svg";
import errorIcon from "./assets/live-chat-error-icon.svg";
var LIVE_CHAT_MODULE_ASSETS_MAP = {
  LIVE_CHAT_AVATAR: avatar,
  LIVE_CHAT_ERROR_ICON: errorIcon
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(LIVE_CHAT_MODULE_ASSETS_MAP);
};

// src/live-chat-contract.types.ts
var EventTypes = /* @__PURE__ */ ((EventTypes2) => {
  EventTypes2["CHAT_STARTED"] = "ChatStarted";
  EventTypes2["CHAT_ENDED"] = "ChatEnded";
  EventTypes2["CHAT_RECONNECTED"] = "ChatReconnected";
  EventTypes2["END_CHAT"] = "EndChat";
  EventTypes2["EVENT_ACKNOWLEDGED"] = "EventAcknowledged";
  EventTypes2["ERROR_RECEIVED"] = "ErrorReceived";
  EventTypes2["MESSAGE"] = "Message";
  EventTypes2["PARTICIPANT_JOINED"] = "ParticipantJoined";
  EventTypes2["PARTICIPANT_LEFT"] = "ParticipantLeft";
  EventTypes2["PARTICIPANT_TYPING"] = "ParticipantTyping";
  EventTypes2["START_CHAT"] = "StartChat";
  EventTypes2["TRANSFER_REQUESTED"] = "TransferRequested";
  EventTypes2["TRANSFER_REQUEST_DONE"] = "TransferRequestDone";
  EventTypes2["WAITING_ROOM"] = "WaitingRoom";
  EventTypes2["SET_VISIBILITY"] = "SetVisibility";
  return EventTypes2;
})(EventTypes || {});
var ErrorTypes = /* @__PURE__ */ ((ErrorTypes2) => {
  ErrorTypes2["MESSAGE_FAILED"] = "MessageFailed";
  ErrorTypes2["DEFAULT"] = "Default";
  return ErrorTypes2;
})(ErrorTypes || {});
var ChatEndedReasonTypes = /* @__PURE__ */ ((ChatEndedReasonTypes2) => {
  ChatEndedReasonTypes2["INITIAL"] = "";
  ChatEndedReasonTypes2["AGENT_DISCONNECTED"] = "AGENT_DISCONNECTED";
  ChatEndedReasonTypes2["USER_DISCONNECTED"] = "USER_DISCONNECTED";
  ChatEndedReasonTypes2["CONNECTION_LOST"] = "CONNECTION_LOST";
  ChatEndedReasonTypes2["CHAT_UNAVAILABLE"] = "CHAT_UNAVAILABLE";
  return ChatEndedReasonTypes2;
})(ChatEndedReasonTypes || {});
var VisibilityState = /* @__PURE__ */ ((VisibilityState3) => {
  VisibilityState3["EXPANDED"] = "EXPANDED";
  VisibilityState3["COLLAPSED"] = "COLLAPSED";
  return VisibilityState3;
})(VisibilityState || {});

// src/hooks/use-live-chat-repository.hook.ts
import React from "react";

// src/utils/live-chat-machine.utils.ts
import { createMachine, interpret, raise } from "xstate";
import { v4 as uuidv4 } from "uuid";
import { subscribeToConfig } from "@leagueplatform/config";
var createMachineContext = (liveChatClient) => ({
  client: liveChatClient,
  chatEndedReason: {
    type: "" /* INITIAL */
  },
  toastErrors: [],
  events: [],
  failedMessagesEventIds: [],
  chips: [],
  queueTitle: "",
  queueDescription: "",
  participants: [],
  visibility: "COLLAPSED" /* COLLAPSED */,
  unreadMessageCount: 0,
  isAgentTyping: false,
  isConnectingToAgentWhileChatActive: false
});
var isParticipantUser = (participant) => !!participant.isUser;
var liveChatMachine = createMachine(
  {
    id: "liveChat",
    initial: "idle",
    predictableActionArguments: true,
    invoke: {
      /**
       * TODO: when upgrading to xstate v5, replace this callback service
       * with a callback actor. (https://stately.ai/docs/callback-actors)
       */
      id: "subscribeToAgentChatEvents",
      src: "subscribeToAgentChatEvents"
    },
    context: {},
    on: {
      ErrorReceived: { actions: ["errorReceived"] },
      ClearError: { actions: ["clearError"] }
    },
    states: {
      idle: {
        entry: ["resetContext"],
        on: {
          StartChat: { target: "connecting", actions: ["startChat"] }
        }
      },
      connecting: {
        entry: raise({
          type: "SetVisibility" /* SET_VISIBILITY */,
          eventId: uuidv4(),
          visibility: "EXPANDED" /* EXPANDED */
        }),
        on: {
          ChatStarted: { target: "chatActive", actions: ["chatStarted"] },
          WaitingRoom: {
            target: "chatQueued",
            actions: ["queueChat"]
          },
          ChatEnded: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          EndChat: {
            target: "idle",
            actions: ["endChat"]
          },
          SetVisibility: {
            actions: ["setVisibility"]
          }
        }
      },
      chatQueued: {
        on: {
          ChatStarted: { target: "chatActive", actions: ["chatStarted"] },
          WaitingRoom: {
            actions: ["queueChat"]
          },
          ChatEnded: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          EndChat: {
            target: "idle",
            actions: ["endChat"]
          },
          SetVisibility: {
            actions: ["setVisibility"]
          }
        }
      },
      chatActive: {
        on: {
          ParticipantTyping: {
            actions: ["participantTyping"]
          },
          ChatEnded: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          EndChat: {
            target: "idle",
            actions: ["endChat"]
          },
          ClearChips: { actions: ["clearChips"] },
          ClearMessages: { actions: ["clearMessages"] },
          // Per requirements
          // Chips should always be cleared when a message is sent or received
          Message: {
            actions: ["clearChips", "message"]
          },
          ParticipantJoined: {
            actions: ["participantJoined"]
          },
          ParticipantLeft: { actions: ["participantLeft"] },
          TransferRequested: {
            actions: ["transferRequested"]
          },
          WaitingRoom: {
            target: "chatQueued",
            actions: ["queueChat"]
          },
          SetVisibility: {
            actions: ["setVisibility"]
          }
        }
      },
      chatInactive: {
        exit: raise({
          type: "SetVisibility" /* SET_VISIBILITY */,
          eventId: uuidv4(),
          visibility: "COLLAPSED" /* COLLAPSED */
        }),
        on: {
          EndChat: {
            target: "idle",
            actions: ["endChat"]
          },
          SetVisibility: {
            actions: ["setVisibility"]
          }
        }
      }
    }
  },
  {
    actions: {
      startChat: (context, event) => {
        context.events.push(event);
        context.client.handleUserChatEvents(event);
      },
      chatStarted: (context, event) => {
        context.events.push(event);
      },
      queueChat: (context, event) => {
        var _a, _b;
        const waitingRoomEvent = event;
        context.queueTitle = (_a = waitingRoomEvent == null ? void 0 : waitingRoomEvent.title) != null ? _a : "";
        context.queueDescription = (_b = waitingRoomEvent == null ? void 0 : waitingRoomEvent.description) != null ? _b : "";
        context.events.push(waitingRoomEvent);
      },
      clearChips: (context) => {
        context.chips = [];
      },
      clearMessages: (context) => {
        context.events = [];
      },
      message: (context, event) => {
        const typedEvent = event;
        if (isParticipantUser(typedEvent.sender)) {
          if (typedEvent.chips) {
            context.events.push(__spreadProps(__spreadValues({}, typedEvent), {
              message: typedEvent.chips[0].label
            }));
          } else if (context.failedMessagesEventIds.includes(typedEvent.eventId)) {
            const indexOfRetriedMessage = context.failedMessagesEventIds.indexOf(typedEvent.eventId);
            context.failedMessagesEventIds.splice(indexOfRetriedMessage, 1);
            context.events = context.events.map((_event) => {
              if (_event.eventId === typedEvent.eventId) {
                return typedEvent;
              }
              return _event;
            });
          } else {
            context.events.push(typedEvent);
          }
          context.client.handleUserChatEvents(typedEvent);
        } else {
          if (typedEvent.message || typedEvent.attachments || typedEvent.card) {
            context.events.push(typedEvent);
            if (context.visibility === "COLLAPSED" /* COLLAPSED */) {
              context.unreadMessageCount += 1;
            }
          }
          if (typedEvent.chips && typedEvent.chips.length > 0) {
            context.chips = typedEvent.chips;
          }
        }
      },
      participantJoined: (context, event) => {
        const typedEvent = event;
        context.events.push(typedEvent);
        const participantId = typedEvent.participant.id;
        const participantJoinedIndex = context.participants.findIndex(
          (participant) => participant.id === participantId
        );
        if (participantJoinedIndex === -1) {
          context.participants.push(typedEvent.participant);
        }
        context.isConnectingToAgentWhileChatActive = false;
      },
      participantLeft: (context, event) => {
        const typedEvent = event;
        context.events.push(typedEvent);
        const participantId = typedEvent.participant.id;
        const participantLeftIndex = context.participants.findIndex(
          (participant) => participant.id === participantId
        );
        if (participantLeftIndex > -1) {
          context.participants.splice(participantLeftIndex, 1);
        }
      },
      transferRequested: (context, event) => {
        const typedEvent = event;
        context.events.push(typedEvent);
        context.isConnectingToAgentWhileChatActive = true;
      },
      participantTyping: (context, event) => {
        const typedEvent = event;
        if (typedEvent.participant && isParticipantUser(typedEvent.participant)) {
          context.client.handleUserChatEvents(typedEvent);
        } else {
          context.isAgentTyping = typedEvent.isTyping;
        }
      },
      resetContext: (context) => {
        Object.assign(context, createMachineContext(context.client));
      },
      endChat: (context, event) => {
        const typedEvent = event;
        context.client.handleUserChatEvents(typedEvent);
      },
      chatEnded: (context, event) => {
        const typedEvent = event;
        context.chatEndedReason = typedEvent.reason;
        context.events.push(typedEvent);
      },
      errorReceived: (context, event) => {
        const typedEvent = event;
        const isMessageFailed = typedEvent.errorType.type === "MessageFailed" /* MESSAGE_FAILED */;
        if (isMessageFailed) {
          const failedMessageErrorType = typedEvent.errorType;
          const failedMessageId = failedMessageErrorType.eventOriginId;
          if (failedMessageId) {
            context.failedMessagesEventIds.push(failedMessageId);
          }
        } else {
          context.toastErrors.push(typedEvent);
          context.events.push(typedEvent);
        }
      },
      clearError: (context, event) => {
        context.toastErrors = context.toastErrors.filter(
          (error) => error.eventId !== event.eventId
        );
      },
      setVisibility: (context, event) => {
        const typedEvent = event;
        const newVisibilityState = typedEvent.visibility;
        context.visibility = newVisibilityState;
        if (newVisibilityState === "EXPANDED" /* EXPANDED */) {
          context.unreadMessageCount = 0;
        }
      }
    },
    services: {
      subscribeToAgentChatEvents: (context) => (send) => {
        context.client.subscribeToAgentChatEvents((event) => {
          send(event);
        });
      }
    }
  }
);
var actor;
var getActor = () => {
  if (!actor) {
    throw new Error(
      "Unable to get liveChatMachine actor, because one was never created! Are you sure that a liveChatClient was provided as part of your LeagueConfig?"
    );
  }
  return actor;
};
var createActor = (liveChatClient) => interpret(liveChatMachine.withContext(createMachineContext(liveChatClient)), {
  devTools: false
});
subscribeToConfig(
  ({ config }) => {
    var _a;
    return (_a = config.liveChat) == null ? void 0 : _a.liveChatClient;
  },
  (liveChatClient) => {
    if (liveChatClient) {
      actor = createActor(liveChatClient);
      actor.start();
    }
  }
);

// src/utils/send-user-event.util.ts
var sendUserEvent = (event) => {
  const liveChatMachine3 = getActor();
  liveChatMachine3.send(event);
};

// src/utils/live-chat-repository.util.ts
var ChatSessionState = /* @__PURE__ */ ((ChatSessionState2) => {
  ChatSessionState2["idle"] = "NotStarted";
  ChatSessionState2["connecting"] = "WaitingRoom";
  ChatSessionState2["chatQueued"] = "WaitingRoom";
  ChatSessionState2["chatActive"] = "Started";
  ChatSessionState2["chatInactive"] = "Ended";
  return ChatSessionState2;
})(ChatSessionState || {});
var getLiveChatState = (machineState) => {
  const currentState = machineState.toStrings()[0];
  return {
    events: machineState.context.events,
    chips: machineState.context.chips,
    participants: machineState.context.participants,
    // TODO: https://everlong.atlassian.net/browse/PCHAT-4950
    // remove lastSeenTimestamp for next major release
    lastSeenTimestamp: void 0,
    chatSessionState: ChatSessionState[currentState],
    visibility: machineState.context.visibility,
    unreadMessageCount: machineState.context.unreadMessageCount
  };
};
var liveChatRepository = {
  subscribe: (subscriber) => {
    const liveChatMachineActor = getActor();
    return liveChatMachineActor.subscribe((state) => {
      const liveChatState = getLiveChatState(state);
      subscriber(liveChatState);
    });
  },
  sendUserEvent
};

// src/hooks/use-live-chat-repository.hook.ts
var useLiveChatRepository = () => {
  const [liveChatState, setLiveChatState] = React.useState(
    () => {
      const actor2 = getActor();
      return getLiveChatState(actor2.getSnapshot());
    }
  );
  React.useEffect(() => {
    const subscription = liveChatRepository.subscribe((state) => {
      setLiveChatState(state);
    });
    return () => subscription.unsubscribe();
  }, []);
  return { liveChatState, sendUserEvent: liveChatRepository.sendUserEvent };
};

// src/hooks/use-live-chat-cta.hook.ts
import React2 from "react";
import { LEAGUE_MODULE_NAMES, getModulePath } from "@leagueplatform/core";
import {
  useNavigateLegacy as useNavigate,
  useLocationLegacy as useLocation
} from "@leagueplatform/routing";

// src/utils/set-chat-visibility.util.ts
import { v4 as uuidv42 } from "uuid";
var setChatVisibility = (visibilityState) => {
  sendUserEvent({
    type: "SetVisibility" /* SET_VISIBILITY */,
    eventId: uuidv42(),
    visibility: visibilityState
  });
};

// src/hooks/use-live-chat-cta.hook.ts
var useLiveChatCta = () => {
  const { liveChatState } = useLiveChatRepository();
  const { unreadMessageCount, chatSessionState, visibility } = liveChatState;
  const navigate = useNavigate();
  const location = useLocation();
  const liveChatButtonRef = React2.useRef(null);
  const previousVisibilityRef = React2.useRef(visibility);
  const liveChatLink = getModulePath(LEAGUE_MODULE_NAMES.liveChat);
  React2.useEffect(() => {
    if ((liveChatButtonRef == null ? void 0 : liveChatButtonRef.current) && previousVisibilityRef.current === "EXPANDED" /* EXPANDED */ && visibility === "COLLAPSED" /* COLLAPSED */) {
      liveChatButtonRef.current.focus();
    }
    previousVisibilityRef.current = visibility;
  }, [visibility]);
  const openChat = React2.useCallback(() => {
    if (chatSessionState === "NotStarted") {
      navigate(liveChatLink);
      return;
    }
    setChatVisibility(
      visibility === "EXPANDED" /* EXPANDED */ ? "COLLAPSED" /* COLLAPSED */ : "EXPANDED" /* EXPANDED */
    );
  }, [chatSessionState, navigate, liveChatLink, visibility]);
  const isVisible = React2.useMemo(
    () => location.pathname !== liveChatLink && visibility === "COLLAPSED" /* COLLAPSED */,
    [liveChatLink, location.pathname, visibility]
  );
  return {
    isVisible,
    unreadMessageCount,
    openChat,
    liveChatButtonRef,
    liveChatLink: chatSessionState === "NotStarted" ? liveChatLink : null,
    shouldShowSkipLink: location.pathname !== liveChatLink
  };
};

// src/components/live-chat-container/live-chat-container.component.tsx
import React22 from "react";

// src/components/chat-container/chat-container.component.tsx
import React3 from "react";
import {
  Modal,
  useMediaQuery,
  queryHelpers
} from "@leagueplatform/genesis-core";

// src/constants/live-chat.constants.ts
var CHAT_HEADING_ID = "chat-heading";

// src/components/chat-container/chat-container.component.tsx
var DEFAULT_HEIGHT = "80vh";
var DEFAULT_WIDTH = "430px";
function ChatContainer({
  children,
  isOpen,
  onOpenChange,
  mobileChatWindowVerticalOffset = "0px",
  layout = "fullscreen",
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  css
}) {
  const isMobile = useMediaQuery(queryHelpers.only("mobile"));
  const isDefaultPosition = layout === "fullscreen";
  return /* @__PURE__ */ React3.createElement(Modal.Root, { modal: !!isMobile, open: isOpen, onOpenChange }, /* @__PURE__ */ React3.createElement(
    Modal.Content,
    {
      showCloseButton: false,
      layout,
      onInteractOutside: (event) => event.preventDefault(),
      "aria-labelledby": CHAT_HEADING_ID,
      css: {
        ".GDS-modal": __spreadValues(__spreadProps(__spreadValues({
          width,
          height
        }, isDefaultPosition && {
          bottom: "35px",
          insetInlineEnd: "35px",
          top: "auto",
          insetInlineStart: "auto"
        }), {
          borderColor: "$onSurfaceBorderSubdued",
          borderStyle: "solid",
          borderWidth: "$thin",
          borderRadius: "$small",
          boxShadow: "$card",
          "@mobile": {
            bottom: "0",
            insetInlineEnd: "0",
            width: "100%",
            height: `calc(100vh - ${mobileChatWindowVerticalOffset})`,
            maxHeight: "100%"
          }
        }), css)
      }
    },
    children
  ));
}

// src/components/live-chat-core/live-chat-core.component.tsx
import React21, { useEffect as useEffect5 } from "react";
import { v4 as uuidv45 } from "uuid";

// src/live-chat.config.ts
import { useConfigProperty, LeagueConfigError } from "@leagueplatform/config";
var defaultShouldShowNavigateAway = true;
var useLiveChatConfig = () => {
  const liveChatClient = useConfigProperty("liveChat.liveChatClient");
  if (!liveChatClient) {
    throw new LeagueConfigError(
      "Live Chat client was not provided via config!"
    );
  }
  const shouldShowNavigateAway = useConfigProperty(
    "liveChat.shouldShowNavigateAway",
    defaultShouldShowNavigateAway
  );
  return {
    /**
     * The type definition of `liveChatClient` in the config module is looser than
     * the one this module has access to. We'll coerce the config value to our
     * better types.
     */
    liveChatClient,
    shouldShowNavigateAway
  };
};

// src/components/live-chat/live-chat.component.tsx
import React20 from "react";
import { Box as Box14, Modal as Modal4, Spinner, styled as styled4 } from "@leagueplatform/genesis-core";

// src/components/chat-header/chat-header.component.tsx
import React4 from "react";
import { Box, HeadingText, Button } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";

// src/constants/chat-analytics.constants.ts
var LIVE_CHAT_ANALYTICS_SCREEN_NAME = "chat";

// src/components/chat-header/chat-header.component.tsx
function ChatHeader({
  title,
  setShowEndChatModal,
  hideEndChat,
  chatEnded
}) {
  const { formatMessage } = useIntl();
  const endChat = () => {
    setShowEndChatModal(true);
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "end chat",
      chat_closed_by_agent: chatEnded
    });
  };
  return /* @__PURE__ */ React4.createElement(
    Box,
    {
      css: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "$oneAndHalf $one",
        borderBottom: "1px solid $onSurfaceBorderSubdued"
      }
    },
    /* @__PURE__ */ React4.createElement(
      HeadingText,
      {
        level: "2",
        size: "xl",
        css: {
          color: "$onSurfaceTextPrimary"
        }
      },
      title
    ),
    !hideEndChat && /* @__PURE__ */ React4.createElement(Button, { priority: "secondary", quiet: true, onClick: () => endChat() }, formatMessage({ id: "END_CHAT" }))
  );
}

// src/components/live-chat/live-chat.component.tsx
import { useIntl as useIntl12 } from "@leagueplatform/locales";

// src/components/chat-messages-grid/chat-messages-grid.component.tsx
import React13, { useEffect as useEffect2, useRef as useRef2 } from "react";
import { debounce } from "lodash";
import { Box as Box7 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";

// src/components/chat-message/agent-typing-bubble.component.tsx
import React8 from "react";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { Box as Box3, VisuallyHidden as VisuallyHidden2 } from "@leagueplatform/genesis-core";

// src/components/chat-message/chat-message-bubble.component.tsx
import React7 from "react";
import { Box as Box2, ParagraphText } from "@leagueplatform/genesis-core";

// src/components/chat-message/deprecated-chat-message-text-with-inline-links.component.tsx
import React5 from "react";
import linkifyHtml from "linkify-html";
import { HtmlToReact } from "@leagueplatform/web-common";
import { styled } from "@leagueplatform/genesis-core";
import {
  EVENT_NAME as EVENT_NAME2,
  PRODUCT_AREA as PRODUCT_AREA2,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA2,
  trackAnalyticsEvent as trackAnalyticsEvent2
} from "@leagueplatform/analytics";
var StyledLink = styled("a", {
  "p > &": {
    color: "inherit"
  },
  textDecoration: "underline"
});
var DeprecatedChatMessageTextWithInlineLinks = ({
  text
}) => {
  const linkifyOptions = {
    defaultProtocol: "https",
    attributes: {
      rel: "noopener noreferrer"
    }
  };
  const onLinkClick = () => {
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA2.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA2.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "link clicked"
    });
  };
  const RichTextOptions = {
    a: {
      component: StyledLink,
      props: {
        target: "_blank",
        onClick: onLinkClick
      }
    }
  };
  return /* @__PURE__ */ React5.createElement(
    HtmlToReact,
    {
      htmlString: linkifyHtml(text, linkifyOptions),
      options: RichTextOptions
    }
  );
};

// src/components/chat-message/chat-message-text-with-inline-links.component.tsx
import React6, { useCallback } from "react";
import Linkify from "linkify-react";
import { isExternalUrl } from "@leagueplatform/web-common";
import {
  styled as styled2,
  Icon,
  VisuallyHidden,
  useMediaQuery as useMediaQuery2,
  queryHelpers as queryHelpers2
} from "@leagueplatform/genesis-core";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import {
  EVENT_NAME as EVENT_NAME3,
  PRODUCT_AREA as PRODUCT_AREA3,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA3,
  trackAnalyticsEvent as trackAnalyticsEvent3
} from "@leagueplatform/analytics";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/config";

// src/constants/us-phone-regexp.constants.ts
var US_PHONE_REGEXP = /(1-)?(\d{1,3})\D*(\d{3})\D*(\d{4})/g;

// src/constants/start-with-us-phone-regexp.constants.ts
var START_WITH_US_PHONE_REGEXP = new RegExp(
  `^${US_PHONE_REGEXP.source}`
);

// src/utils/is-phone-link.util.ts
var isPhoneLink = (link) => {
  const parts = link.split(".");
  if (parts.length !== 2)
    return false;
  const [phone, domain] = parts;
  return !!phone.match(START_WITH_US_PHONE_REGEXP) && domain === "tel";
};

// src/components/chat-message/chat-message-text-with-inline-links.component.tsx
var linkStyles = {
  "span > &": {
    color: "inherit",
    fontWeight: "inherit"
  }
};
var StyledLink2 = styled2("a", linkStyles);
var StyledRouterLink = styled2(RouterLink, linkStyles);
var ChatMessageTextWithInlineLinks = ({
  text: original
}) => {
  const text = original.replace(US_PHONE_REGEXP, (r) => `${r}.tel`);
  const { formatMessage } = useIntl2();
  const isMobile = useMediaQuery2(queryHelpers2.only("mobile"));
  const { liveChatState } = useLiveChatRepository();
  const handleLinkCallback = useConfigProperty2("core.customMethods.handleLink");
  const onLinkClick = () => {
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA3.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA3.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "link clicked"
    });
  };
  const minimizeChatOnMobile = useCallback(() => {
    if (isMobile && liveChatState.visibility === "EXPANDED" /* EXPANDED */) {
      setChatVisibility("COLLAPSED" /* COLLAPSED */);
    }
  }, [isMobile, liveChatState.visibility]);
  const handleInternalLinkClick = useCallback(() => {
    onLinkClick();
    minimizeChatOnMobile();
  }, [minimizeChatOnMobile]);
  const renderLink = ({ attributes, content }) => {
    const { href } = attributes;
    const baseUrl = window.location.origin;
    if (isPhoneLink(content)) {
      const phone = content.replace(".tel", "");
      const formatPhone = phone.padStart(0, "+").replace(/-/g, "");
      const hrefPhone = `tel:${formatPhone}`;
      return /* @__PURE__ */ React6.createElement(
        StyledLink2,
        {
          href: hrefPhone,
          rel: "noopener noreferrer",
          target: "_blank",
          onClick: () => {
            if (handleLinkCallback) {
              handleLinkCallback(hrefPhone);
              onLinkClick();
            }
          }
        },
        phone
      );
    }
    if (isExternalUrl(href)) {
      return /* @__PURE__ */ React6.createElement(
        StyledLink2,
        {
          href,
          rel: "noopener noreferrer",
          target: "_blank",
          onClick: (e) => {
            if (handleLinkCallback) {
              e.preventDefault();
              handleLinkCallback(href);
              onLinkClick();
            }
          }
        },
        content,
        /* @__PURE__ */ React6.createElement(
          Icon,
          {
            css: {
              marginInlineStart: "$quarter"
            },
            icon: "interfaceExternalLink",
            size: "$one"
          }
        ),
        /* @__PURE__ */ React6.createElement(VisuallyHidden, null, formatMessage({ id: "WARNING_OPENS_NEW_TAB" }))
      );
    }
    const path = href.split(baseUrl)[1];
    return /* @__PURE__ */ React6.createElement(StyledRouterLink, { to: path, onClick: handleInternalLinkClick }, content);
  };
  return /* @__PURE__ */ React6.createElement(Linkify, { as: "span", options: { render: renderLink } }, text);
};

// src/components/chat-message/chat-message-bubble.component.tsx
var AVATAR_WIDTH = "two";
var AVATAR_CONTAINER_INLINE_END_MARGIN = "$half";
var ChatMessageBubble = ({
  backgroundColor,
  color,
  message,
  eventFromCurrentUser
}) => {
  const { shouldShowNavigateAway } = useLiveChatConfig();
  return /* @__PURE__ */ React7.createElement(
    Box2,
    {
      css: __spreadValues({
        width: "100%",
        borderRadius: "$extraLarge",
        paddingTop: "$quarter",
        paddingBottom: "$quarter",
        display: "flex"
      }, eventFromCurrentUser && { justifyContent: "flex-end" })
    },
    /* @__PURE__ */ React7.createElement(
      Box2,
      {
        css: {
          backgroundColor: `${backgroundColor}`,
          borderRadius: "$extraLarge",
          padding: "$threeQuarters",
          width: "fit-content",
          maxWidth: shouldShowNavigateAway ? "85%" : "70%",
          "@mobile": __spreadValues({
            maxWidth: shouldShowNavigateAway ? "90%" : "70%"
          }, eventFromCurrentUser && {
            maxWidth: shouldShowNavigateAway ? `calc(100% - $${AVATAR_WIDTH} - ${AVATAR_CONTAINER_INLINE_END_MARGIN})` : "70%"
          })
        }
      },
      /* @__PURE__ */ React7.createElement(
        ParagraphText,
        {
          css: {
            wordBreak: "break-word",
            color
          }
        },
        message && (shouldShowNavigateAway ? /* @__PURE__ */ React7.createElement(ChatMessageTextWithInlineLinks, { text: message }) : /* @__PURE__ */ React7.createElement(DeprecatedChatMessageTextWithInlineLinks, { text: message }))
      )
    )
  );
};

// src/components/chat-message/agent-typing-bubble.component.tsx
var AgentTypingBubble = () => {
  const { formatMessage } = useIntl3();
  return /* @__PURE__ */ React8.createElement(
    Box3,
    {
      role: "row",
      css: {
        marginBottom: "$one"
      }
    },
    /* @__PURE__ */ React8.createElement(
      Box3,
      {
        css: {
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start"
        }
      },
      /* @__PURE__ */ React8.createElement(
        Box3,
        {
          css: {
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%",
            marginInlineStart: "$twoAndHalf"
          }
        },
        /* @__PURE__ */ React8.createElement(Box3, { "aria-hidden": true }, /* @__PURE__ */ React8.createElement(
          ChatMessageBubble,
          {
            backgroundColor: "$surfaceBackgroundTertiary",
            color: "$onSurfaceTextPrimary",
            message: "..."
          }
        )),
        /* @__PURE__ */ React8.createElement(VisuallyHidden2, null, formatMessage({ id: "LIVE_CHAT_AGENT_TYPING_BUBBLE_ALT" }))
      )
    )
  );
};

// src/components/system-message/system-message.component.tsx
import React9 from "react";
import {
  Box as Box4,
  ParagraphText as ParagraphText2,
  styled as styled3
} from "@leagueplatform/genesis-core";
var Line = styled3(Box4, {
  flex: 1,
  borderTop: "1px solid $onSurfaceBorderDefault",
  minWidth: "$one"
});
var SystemMessage = ({
  text,
  secondaryText,
  emphasis
}) => /* @__PURE__ */ React9.createElement(
  Box4,
  {
    css: {
      display: "flex",
      alignItems: "center",
      marginBottom: "$one"
    }
  },
  /* @__PURE__ */ React9.createElement(Line, null),
  /* @__PURE__ */ React9.createElement(
    Box4,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "$half"
      }
    },
    /* @__PURE__ */ React9.createElement(
      ParagraphText2,
      {
        size: "sm",
        emphasis,
        css: {
          padding: "0 $half",
          margin: "0 !important",
          textAlign: "center",
          typography: emphasis === "subtle" ? "$bodyTwo" : "$subtitleTwo"
        }
      },
      text
    ),
    secondaryText && /* @__PURE__ */ React9.createElement(
      ParagraphText2,
      {
        size: "sm",
        emphasis,
        css: {
          padding: "0 $half",
          margin: "0 !important",
          textAlign: "center",
          typography: emphasis === "subtle" ? "$bodyTwo" : "$subtitleTwo"
        }
      },
      secondaryText
    )
  ),
  /* @__PURE__ */ React9.createElement(Line, null)
);

// src/components/chat-message/chat-message.component.tsx
import React12, { useEffect, useRef, useState } from "react";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { Box as Box6, UtilityText } from "@leagueplatform/genesis-core";
import { Avatar } from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/components/chat-message/chat-message-card.component.tsx
import React10 from "react";
import {
  Card,
  Button as Button2,
  HeadingText as HeadingText2,
  Box as Box5,
  ParagraphText as ParagraphText3,
  useMediaQuery as useMediaQuery3,
  queryHelpers as queryHelpers3
} from "@leagueplatform/genesis-core";

// src/constants/chat-message.constants.ts
var CHAT_MESSAGE_CARD_MAX_WIDTH = 373;

// src/components/chat-message/chat-message-card.component.tsx
import {
  EVENT_NAME as EVENT_NAME4,
  PRODUCT_AREA as PRODUCT_AREA4,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA4,
  trackAnalyticsEvent as trackAnalyticsEvent4
} from "@leagueplatform/analytics";
import { isExternalUrl as isExternalUrl2 } from "@leagueplatform/web-common";
import { useNavigateLegacy as useNavigate2 } from "@leagueplatform/routing";
import { useConfigProperty as useConfigProperty3 } from "@leagueplatform/config";
var ChatMessageCard = ({
  title,
  subtitle,
  buttons
}) => {
  const navigate = useNavigate2();
  const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/\S*)?$/;
  const { shouldShowNavigateAway } = useLiveChatConfig();
  const { liveChatState } = useLiveChatRepository();
  const isMobile = useMediaQuery3(queryHelpers3.only("mobile"));
  const handleLinkCallback = useConfigProperty3("core.customMethods.handleLink");
  const openCardLink = (urlString) => {
    if (!urlString)
      return;
    const url = /^https?:\/\//i.test(urlString) ? urlString : `https://${urlString}`;
    if (shouldShowNavigateAway) {
      if (isExternalUrl2(url)) {
        if (handleLinkCallback) {
          handleLinkCallback(url);
        } else {
          window.open(url, "_blank");
        }
      } else {
        const baseUrl = window.location.origin;
        const path = url.split(baseUrl)[1];
        navigate(path);
        if (isMobile && liveChatState.visibility === "EXPANDED" /* EXPANDED */) {
          setChatVisibility("COLLAPSED" /* COLLAPSED */);
        }
      }
    }
    if (!shouldShowNavigateAway) {
      if (handleLinkCallback) {
        handleLinkCallback(url);
      } else {
        window.open(url, "_blank");
      }
    }
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA4.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA4.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "message card clicked"
    });
  };
  const validButtons = buttons.filter(
    (button) => button.value && urlRegex.test(button.value)
  );
  return /* @__PURE__ */ React10.createElement(
    Card.Elevated,
    {
      css: {
        maxWidth: `${CHAT_MESSAGE_CARD_MAX_WIDTH}px`,
        flexBasis: `${CHAT_MESSAGE_CARD_MAX_WIDTH}px`,
        flex: 1
      }
    },
    /* @__PURE__ */ React10.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React10.createElement(HeadingText2, { size: "md", level: "4" }, title)),
    subtitle && /* @__PURE__ */ React10.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React10.createElement(ParagraphText3, { emphasis: "subtle" }, subtitle)),
    /* @__PURE__ */ React10.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React10.createElement(
      Box5,
      {
        css: {
          display: "flex",
          justifyContent: "flex-start",
          gap: "$half"
        }
      },
      validButtons.map((button, i) => {
        const key = `${button.label}-${button.value}-${i}`;
        return (
          // TODO: we need to conditionally render a router link or link instead of a button for a11y purposes
          // https://everlong.atlassian.net/browse/PCHAT-5376
          /* @__PURE__ */ React10.createElement(
            Button2,
            {
              key,
              onClick: () => openCardLink(button.value),
              width: "fillContainer",
              size: "medium"
            },
            button.label
          )
        );
      })
    ))
  );
};

// src/components/chat-message/message-failure-modal.component.tsx
import React11 from "react";
import {
  Modal as Modal2,
  Button as Button3,
  ParagraphText as ParagraphText4,
  HeadingText as HeadingText3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
var MessageFailureModal = ({
  handleRetry
}) => {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React11.createElement(Modal2.Root, null, /* @__PURE__ */ React11.createElement(Modal2.Trigger, null, /* @__PURE__ */ React11.createElement(
    Button3,
    {
      hideLabel: true,
      destructive: true,
      quiet: true,
      priority: "secondary",
      icon: "statusAlert",
      size: "large"
    },
    formatMessage({ id: "LIVE_CHAT_RESEND_MESSAGE" })
  )), /* @__PURE__ */ React11.createElement(Modal2.Content, { forceModalFocus: false }, /* @__PURE__ */ React11.createElement(Modal2.Title, null, /* @__PURE__ */ React11.createElement(HeadingText3, { size: "sm", level: "2", css: { textAlign: "center" } }, formatMessage({ id: "LIVE_CHAT_MESSAGE_FAILED_TITLE" }))), /* @__PURE__ */ React11.createElement(ParagraphText4, { css: { textAlign: "center", marginTop: "$one" } }, formatMessage({ id: "LIVE_CHAT_MESSAGE_FAILED_BODY" })), /* @__PURE__ */ React11.createElement(
    Button3,
    {
      size: "medium",
      css: { display: "block", width: "100%", marginTop: "$one" },
      onClick: handleRetry
    },
    formatMessage({ id: "TRY_AGAIN" })
  ), /* @__PURE__ */ React11.createElement(Modal2.Close, null, /* @__PURE__ */ React11.createElement(
    Button3,
    {
      priority: "secondary",
      size: "medium",
      quiet: true,
      css: {
        width: "100%",
        display: "block",
        marginTop: "$threeQuarters"
      }
    },
    formatMessage({ id: "RETURN_TO_CHAT" })
  ))));
};

// src/components/chat-message/chat-message.component.tsx
var ChatMessageFromCurrentUser = ({
  message,
  messageFailed,
  time,
  eventId,
  sender,
  userId
}) => {
  const { formatMessage } = useIntl5();
  const chatMessageRef = useRef(null);
  const [isFocusable, setIsFocusable] = useState(false);
  const [redirectFocusOnResend, setRedirectFocusOnResend] = useState(false);
  useEffect(() => {
    if (messageFailed) {
      setIsFocusable(true);
    }
  }, [messageFailed]);
  useEffect(() => {
    if (redirectFocusOnResend && chatMessageRef.current) {
      chatMessageRef.current.focus();
    }
  }, [redirectFocusOnResend]);
  const resetFocus = () => {
    if (!messageFailed) {
      setIsFocusable(false);
    }
  };
  return /* @__PURE__ */ React12.createElement(
    Box6,
    {
      css: {
        marginBottom: "$one"
      }
    },
    /* @__PURE__ */ React12.createElement(
      Box6,
      {
        css: {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start"
        }
      },
      /* @__PURE__ */ React12.createElement(
        Box6,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "100%"
          },
          tabIndex: isFocusable ? -1 : void 0,
          ref: chatMessageRef,
          onBlur: resetFocus
        },
        /* @__PURE__ */ React12.createElement(
          ChatMessageBubble,
          {
            backgroundColor: "$primaryBackgroundDefault",
            color: "$onSurfaceTextReversed",
            message,
            eventFromCurrentUser: true
          }
        ),
        /* @__PURE__ */ React12.createElement(
          UtilityText,
          {
            size: "xs",
            css: {
              marginInlineStart: "$twoAndHalf",
              color: "$onSurfaceTextSubdued"
            }
          },
          messageFailed ? formatMessage({ id: "LIVE_CHAT_DELIVERY_FAILURE" }) : time
        )
      ),
      messageFailed && /* @__PURE__ */ React12.createElement(
        MessageFailureModal,
        {
          handleRetry: () => {
            sendUserEvent({
              eventId,
              type: "Message" /* MESSAGE */,
              message,
              sender: {
                name: sender.name,
                id: userId,
                isUser: true
              },
              timestamp: /* @__PURE__ */ new Date()
            });
            setRedirectFocusOnResend(true);
          }
        }
      )
    )
  );
};
var ChatMessageFromOtherUser = ({
  message,
  card,
  sender,
  time
}) => {
  const avatar2 = handleStaticAsset(
    "LIVE_CHAT_AVATAR" /* LIVE_CHAT_AVATAR */
  );
  return /* @__PURE__ */ React12.createElement(
    Box6,
    {
      css: {
        marginBottom: "$one"
      }
    },
    /* @__PURE__ */ React12.createElement(
      Box6,
      {
        css: {
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start"
        }
      },
      /* @__PURE__ */ React12.createElement(
        Box6,
        {
          css: {
            width: "$two",
            marginInlineEnd: AVATAR_CONTAINER_INLINE_END_MARGIN,
            marginBottom: "$quarter"
          }
        },
        !card && /* @__PURE__ */ React12.createElement(
          Avatar,
          {
            imageSrc: sender.avatarUrl || avatar2,
            width: AVATAR_WIDTH,
            height: "two",
            fontSize: "caption"
          }
        )
      ),
      card ? /* @__PURE__ */ React12.createElement(
        ChatMessageCard,
        {
          title: card.title,
          subtitle: card == null ? void 0 : card.subtitle,
          buttons: card.buttons
        }
      ) : /* @__PURE__ */ React12.createElement(
        Box6,
        {
          css: {
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%"
          }
        },
        /* @__PURE__ */ React12.createElement(
          UtilityText,
          {
            size: "xs",
            css: {
              color: "$onSurfaceTextSubdued"
            }
          },
          sender.name
        ),
        /* @__PURE__ */ React12.createElement(
          ChatMessageBubble,
          {
            backgroundColor: "$surfaceBackgroundTertiary",
            color: "$onSurfaceTextPrimary",
            message
          }
        )
      )
    ),
    /* @__PURE__ */ React12.createElement(
      UtilityText,
      {
        size: "xs",
        css: {
          marginInlineStart: "$twoAndHalf",
          color: "$onSurfaceTextSubdued"
        }
      },
      time
    )
  );
};
var ChatMessage = ({
  fromCurrentUser,
  messageFailed,
  message,
  card,
  time,
  userId,
  eventId,
  sender
}) => fromCurrentUser ? /* @__PURE__ */ React12.createElement(
  ChatMessageFromCurrentUser,
  {
    message,
    time,
    messageFailed,
    sender,
    userId,
    eventId
  }
) : /* @__PURE__ */ React12.createElement(
  ChatMessageFromOtherUser,
  {
    message,
    card,
    time,
    sender
  }
);

// src/components/chat-messages-grid/chat-messages-grid.component.tsx
var handleScroll = debounce((boxRef) => {
  if (boxRef == null ? void 0 : boxRef.current) {
    boxRef.current.scrollTo({
      top: boxRef.current.scrollHeight,
      behavior: "smooth"
    });
  }
}, 250);
var ChatMessagesGrid = ({
  events,
  userId,
  agentIsTyping,
  connectingToAnAgent,
  failedEvents,
  queueData
}) => {
  const { formatMessage, formatTime } = useIntl6();
  const containerRef = useRef2(null);
  useEffect2(() => {
    handleScroll(containerRef);
  }, [events, agentIsTyping, connectingToAnAgent, queueData]);
  return /* @__PURE__ */ React13.createElement(
    Box7,
    {
      ref: containerRef,
      role: "grid",
      "aria-live": "polite",
      "aria-label": formatMessage({ id: "CHATS_IN_CONVERSATION" }),
      css: {
        flexGrow: "1",
        overflowY: "auto",
        padding: "$oneAndHalf $one",
        display: "flex",
        flexDirection: "column"
      }
    },
    events == null ? void 0 : events.map((data) => {
      var _a, _b;
      let messageFailed = -1;
      if (failedEvents) {
        messageFailed = failedEvents.findIndex(
          (failedEventId) => failedEventId === data.eventId
        );
      }
      return /* @__PURE__ */ React13.createElement(Box7, { key: data.eventId, role: "row" }, /* @__PURE__ */ React13.createElement(Box7, { role: "gridcell" }, data.type === "Message" /* MESSAGE */ && /* @__PURE__ */ React13.createElement(
        ChatMessage,
        {
          fromCurrentUser: data.sender.id === userId,
          messageFailed: messageFailed > -1,
          eventId: data.eventId,
          userId,
          message: (data == null ? void 0 : data.message) || "",
          card: data.card,
          time: formatTime(data.timestamp),
          sender: data.sender
        }
      ), data.type === "ParticipantJoined" /* PARTICIPANT_JOINED */ && /* @__PURE__ */ React13.createElement(
        SystemMessage,
        {
          text: formatMessage(
            { id: "USERNAME_HAS_JOINED_THE_CHAT" },
            { username: (_a = data == null ? void 0 : data.participant) == null ? void 0 : _a.name }
          )
        }
      ), data.type === "ParticipantLeft" /* PARTICIPANT_LEFT */ && /* @__PURE__ */ React13.createElement(
        SystemMessage,
        {
          text: formatMessage(
            { id: "USERNAME_HAS_LEFT_THE_CHAT" },
            { username: (_b = data == null ? void 0 : data.participant) == null ? void 0 : _b.name }
          )
        }
      )));
    }),
    agentIsTyping && /* @__PURE__ */ React13.createElement(AgentTypingBubble, null),
    connectingToAnAgent && /* @__PURE__ */ React13.createElement(
      SystemMessage,
      {
        text: formatMessage({ id: "CONNECTING_YOU_WITH_AN_AGENT" }),
        emphasis: "subtle"
      }
    ),
    queueData && /* @__PURE__ */ React13.createElement(
      SystemMessage,
      {
        text: queueData.queueTitle,
        secondaryText: queueData.queueDescription,
        emphasis: "subtle"
      }
    )
  );
};

// src/components/chat-form/chat-form.component.tsx
import React16, {
  useCallback as useCallback2,
  useRef as useRef3,
  useState as useState2
} from "react";
import {
  Box as Box10,
  Button as Button5,
  InputStatusMessage,
  ParagraphText as ParagraphText5,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { v4 as uuidv43 } from "uuid";

// src/components/chat-message/chat-message-chips.component.tsx
import React14 from "react";
import {
  Box as Box8,
  Button as Button4,
  queryHelpers as queryHelpers4,
  useMediaQuery as useMediaQuery4
} from "@leagueplatform/genesis-core";
import { isExternalUrl as isExternalUrl3 } from "@leagueplatform/web-common";
import { LinkLegacy as RouterLink2 } from "@leagueplatform/routing";
import { useConfigProperty as useConfigProperty4 } from "@leagueplatform/config";
var ChatMessageChips = ({
  chips,
  sendMessage
}) => {
  const isMobile = useMediaQuery4(queryHelpers4.only("mobile"));
  const { liveChatState } = useLiveChatRepository();
  const handleLinkCallback = useConfigProperty4("core.customMethods.handleLink");
  const minimizeChatOnMobileLinkClick = () => {
    if (isMobile && liveChatState.visibility === "EXPANDED" /* EXPANDED */) {
      setChatVisibility("COLLAPSED" /* COLLAPSED */);
    }
  };
  const getChipWithLink = (chip) => {
    var _a;
    if (!chip.link) {
      return null;
    }
    if (isExternalUrl3((_a = chip == null ? void 0 : chip.link) == null ? void 0 : _a.value)) {
      return /* @__PURE__ */ React14.createElement(
        Button4,
        {
          key: chip.label,
          as: "a",
          onClick: (e) => {
            var _a2;
            if (handleLinkCallback && ((_a2 = chip == null ? void 0 : chip.link) == null ? void 0 : _a2.value)) {
              e.preventDefault();
              handleLinkCallback(chip.link.value);
            }
          },
          href: chip.link.value,
          priority: "secondary",
          size: "medium",
          target: "_blank",
          rel: "noreferrer noopener",
          indicator: "externalLink",
          css: {
            margin: "$quarter"
          }
        },
        chip.label
      );
    }
    const baseUrl = window.location.origin;
    const path = chip.link.value.split(baseUrl)[1];
    return /* @__PURE__ */ React14.createElement(
      Button4,
      {
        key: chip.label,
        as: RouterLink2,
        to: path,
        onClick: minimizeChatOnMobileLinkClick,
        priority: "secondary",
        size: "medium",
        css: {
          margin: "$quarter"
        }
      },
      chip.label
    );
  };
  return /* @__PURE__ */ React14.createElement(
    Box8,
    {
      css: {
        display: "flex",
        flexWrap: "wrap",
        paddingBottom: "$one"
      }
    },
    chips == null ? void 0 : chips.map(
      (chip) => chip.link ? getChipWithLink(chip) : /* @__PURE__ */ React14.createElement(
        Button4,
        {
          key: chip.label,
          priority: "secondary",
          size: "medium",
          css: {
            margin: "$quarter"
          },
          onClick: () => sendMessage(chip)
        },
        chip.label
      )
    )
  );
};

// src/hooks/use-get-live-chat-config.hook.ts
import { useQuery } from "@tanstack/react-query";
import {
  getLiveChatConfig,
  LIVE_CHAT_CONFIG_PATH
} from "@leagueplatform/live-chat-api";
var useGetLiveChatConfig = (options) => useQuery(
  [LIVE_CHAT_CONFIG_PATH],
  () => getLiveChatConfig(),
  __spreadValues({
    staleTime: Infinity
  }, options)
);

// src/hooks/use-get-message-max-size.hook.ts
var useGetMessageMaxSize = () => useGetLiveChatConfig({
  select: (data) => data.data.find(
    (config) => {
      var _a;
      return ((_a = config == null ? void 0 : config.attributes) == null ? void 0 : _a.name) === "MESSAGE_MAX_SIZE";
    }
  )
});

// src/components/chat-form/chat-form.component.tsx
import {
  EVENT_NAME as EVENT_NAME5,
  PRODUCT_AREA as PRODUCT_AREA5,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA5,
  trackAnalyticsEvent as trackAnalyticsEvent5
} from "@leagueplatform/analytics";

// src/components/chat-form/autoresize-textarea.component.tsx
import React15, { useEffect as useEffect3 } from "react";
import { Textarea } from "@leagueplatform/genesis-commons";
import { Box as Box9 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
var TEXTAREA_MAX_HEIGHT = 150;
var useAutosizeTextArea = (textAreaRef, value) => {
  useEffect3(() => {
    if (textAreaRef) {
      textAreaRef.style.height = "0px";
      const { scrollHeight } = textAreaRef;
      textAreaRef.style.height = `${Math.min(
        scrollHeight + 2,
        TEXTAREA_MAX_HEIGHT
      )}px`;
    }
  }, [textAreaRef, value]);
};
var AutoResizeTextarea = ({
  id,
  textareaName,
  ariaDescribedby,
  textAreaRef,
  onChange,
  ariaLabel
}) => {
  var _a;
  useAutosizeTextArea(textAreaRef.current, (_a = textAreaRef.current) == null ? void 0 : _a.value);
  const { formatMessage } = useIntl7();
  return /* @__PURE__ */ React15.createElement(
    Box9,
    {
      css: {
        flexBasis: "70%",
        flexGrow: 1,
        flexShrink: 0
      }
    },
    /* @__PURE__ */ React15.createElement(
      Textarea,
      {
        name: textareaName,
        id,
        rows: 1,
        minHeight: "40px",
        borderRadius: "medium",
        resize: "none",
        ref: textAreaRef,
        autoFocus: true,
        "aria-describedby": ariaDescribedby,
        "aria-label": ariaLabel,
        onChange,
        placeholder: formatMessage({ id: "WRITE_A_MESSAGE" })
      }
    )
  );
};

// src/components/chat-form/chat-form.component.tsx
var TYPING_TIMEOUT_MILIS = 2e3;
var ChatForm = ({
  userName,
  userId,
  chipsData,
  chatEnded,
  inWaitingRoom
}) => {
  const { formatMessage } = useIntl8();
  const { data: messageMaxSize } = useGetMessageMaxSize();
  const characterLimit = Number(messageMaxSize == null ? void 0 : messageMaxSize.attributes.value);
  const textAreaRef = React16.useRef(null);
  const [isMessageEmpty, setIsMessageEmpty] = useState2(true);
  const [hasExceededLimit, setHasExceededLimit] = useState2(false);
  const typingTimeoutRef = useRef3();
  const handleChange = useCallback2(
    (event) => {
      const trimmedInputValue = event.target.value.trim();
      setIsMessageEmpty(!trimmedInputValue.length);
      setHasExceededLimit(
        !!characterLimit && event.target.value.length > characterLimit
      );
      if (!typingTimeoutRef.current) {
        sendUserEvent({
          eventId: uuidv43(),
          type: "ParticipantTyping" /* PARTICIPANT_TYPING */,
          isTyping: true,
          participant: {
            id: userId,
            name: userName,
            isUser: true
          }
        });
      } else {
        window.clearTimeout(typingTimeoutRef.current);
      }
      typingTimeoutRef.current = window.setTimeout(() => {
        typingTimeoutRef.current = void 0;
        sendUserEvent({
          eventId: uuidv43(),
          type: "ParticipantTyping" /* PARTICIPANT_TYPING */,
          isTyping: false,
          participant: {
            id: userId,
            name: userName,
            isUser: true
          }
        });
      }, TYPING_TIMEOUT_MILIS);
    },
    [characterLimit, userId, userName]
  );
  const generateMessageEvent = (messageValue) => __spreadProps(__spreadValues({
    type: "Message" /* MESSAGE */,
    eventId: uuidv43(),
    timestamp: /* @__PURE__ */ new Date()
  }, messageValue), {
    sender: {
      id: userId,
      name: userName,
      isUser: true
    }
  });
  const handleSend = () => {
    if (!textAreaRef.current) {
      return;
    }
    const messageEvent = generateMessageEvent({
      message: textAreaRef.current.value
    });
    sendUserEvent(messageEvent);
    textAreaRef.current.value = "";
    trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA5.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA5.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "send"
    });
  };
  const sendMessage = (chip) => {
    const messageEvent = generateMessageEvent({ chips: [chip] });
    sendUserEvent(messageEvent);
    trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA5.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA5.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "suggestion chip clicked"
    });
  };
  if (chatEnded) {
    return /* @__PURE__ */ React16.createElement(Box10, null, /* @__PURE__ */ React16.createElement(
      ParagraphText5,
      {
        size: "sm",
        css: {
          textAlign: "center",
          typography: "$subtitleOne",
          color: "$onSurfaceTextCritical",
          marginBottom: "$two"
        }
      },
      formatMessage({ id: "CHAT_CLOSED" })
    ));
  }
  return /* @__PURE__ */ React16.createElement(Box10, { css: { padding: "$oneAndHalf $one" } }, chipsData.length > 0 && /* @__PURE__ */ React16.createElement(ChatMessageChips, { chips: chipsData, sendMessage }), /* @__PURE__ */ React16.createElement(
    Box10,
    {
      css: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gap: "$half"
      }
    },
    /* @__PURE__ */ React16.createElement(
      AutoResizeTextarea,
      {
        id: "chat-message-input",
        textareaName: formatMessage({ id: "CHAT_MESSAGE_INPUT" }),
        textAreaRef,
        onChange: handleChange,
        ariaLabel: formatMessage({ id: "CHAT_MESSAGE_INPUT" }),
        ariaDescribedby: hasExceededLimit ? "errorMessage" : void 0
      }
    ),
    /* @__PURE__ */ React16.createElement(
      Button5,
      {
        disabled: isMessageEmpty || hasExceededLimit || inWaitingRoom,
        onClick: () => handleSend()
      },
      formatMessage({ id: "SEND" })
    )
  ), hasExceededLimit && /* @__PURE__ */ React16.createElement(InputStatusMessage, { inputStatus: "error", id: "errorMessage" }, formatMessage(
    { id: "LIVE_CHAT_CHARACTER_LIMIT" },
    {
      characterLimit
    }
  )), /* @__PURE__ */ React16.createElement(VisuallyHidden3, { "aria-live": "polite" }, chipsData.length > 0 && /* @__PURE__ */ React16.createElement(ParagraphText5, null, formatMessage({ id: "LIVE_CHAT_FEED_NEW_CHIPS_ALT" }))));
};

// src/components/live-chat/live-chat.component.tsx
import { useGetUserProfile } from "@leagueplatform/web-common";
import { v4 as uuidv44 } from "uuid";
import { ErrorState } from "@leagueplatform/web-common-components";
import { useNavigateLegacy as useNavigate4 } from "@leagueplatform/routing";
import {
  EVENT_NAME as EVENT_NAME8,
  PRODUCT_AREA as PRODUCT_AREA8,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA8,
  trackAnalyticsEvent as trackAnalyticsEvent8
} from "@leagueplatform/analytics";

// src/components/live-chat-error-toast/live-chat-error-toast.component.tsx
import React17 from "react";
import { Box as Box11, ParagraphText as ParagraphText6, StatusBanner } from "@leagueplatform/genesis-core";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
function LiveChatErrorToast({
  toastErrors,
  clearToastError
}) {
  const { formatMessage } = useIntl9();
  const title = formatMessage({ id: "LIVE_CHAT_GENERIC_TOAST_ERROR_TITLE" });
  return /* @__PURE__ */ React17.createElement(Box11, { css: { position: "relative" } }, toastErrors.map((toastError) => {
    var _a, _b;
    const description = (_b = (_a = toastError.errorType) == null ? void 0 : _a.message) != null ? _b : formatMessage({ id: "LIVE_CHAT_GENERIC_TOAST_ERROR_DESCRIPTION" });
    return /* @__PURE__ */ React17.createElement(
      StatusBanner,
      {
        key: toastError.eventId,
        icon: "statusInformationCircleFill",
        onDismissClick: () => clearToastError(toastError.eventId),
        status: "error",
        title,
        css: {
          position: "absolute",
          bottom: "$one",
          insetInlineEnd: "$oneAndHalf",
          maxWidth: "50%",
          "@mobile": {
            maxWidth: "100%",
            bottom: "0",
            insetInlineEnd: "0"
          }
        }
      },
      /* @__PURE__ */ React17.createElement(
        ParagraphText6,
        {
          emphasis: "subtle",
          css: {
            typography: "$bodyTwo",
            color: "$onSurfaceTextPrimary"
          }
        },
        description
      )
    );
  }));
}

// src/components/chat-top-bar/chat-top-bar.component.tsx
import React18 from "react";
import { Box as Box12, HeadingText as HeadingText4, Button as Button6 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME6,
  PRODUCT_AREA as PRODUCT_AREA6,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA6,
  trackAnalyticsEvent as trackAnalyticsEvent6
} from "@leagueplatform/analytics";
var buttonFocusStyles = {
  "&:focus, &:hover, &:active": {
    backgroundColor: "$primaryBackgroundHovered",
    outline: "$borderWidths$thick solid $colors$primaryTextDefault !important",
    outlineOffset: "-$borderWidths$thick !important"
  }
};
function ChatTopBar({
  title,
  setShowEndChatModal,
  chatEnded,
  onMinimizeChat,
  hideEndChat,
  hideMinimizeChat,
  autofocus,
  endChatButtonRef
}) {
  const { formatMessage } = useIntl10();
  const minimizeButtonRef = React18.useRef(null);
  React18.useEffect(() => {
    var _a;
    if (autofocus) {
      (_a = minimizeButtonRef == null ? void 0 : minimizeButtonRef.current) == null ? void 0 : _a.focus();
    }
  }, [autofocus]);
  const endChat = React18.useCallback(() => {
    setShowEndChatModal(true);
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA6.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA6.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "end chat",
      chat_closed_by_agent: chatEnded
    });
  }, [chatEnded, setShowEndChatModal]);
  return /* @__PURE__ */ React18.createElement(
    Box12,
    {
      css: {
        display: "flex",
        justifyContent: hideMinimizeChat ? "flex-end" : "space-between",
        alignItems: "center",
        paddingY: "$quarter",
        background: "$primaryBackgroundDefault",
        position: "relative",
        minHeight: "58px"
      }
    },
    !hideMinimizeChat && /* @__PURE__ */ React18.createElement(
      Button6,
      {
        icon: "interfaceChevronDown",
        hideLabel: true,
        onClick: onMinimizeChat,
        css: __spreadValues({
          padding: "$half",
          marginInlineStart: "$quarter"
        }, buttonFocusStyles),
        ref: minimizeButtonRef
      },
      formatMessage({ id: "LIVE_CHAT_TOP_BAR_MINIMIZE" })
    ),
    /* @__PURE__ */ React18.createElement(
      HeadingText4,
      {
        id: CHAT_HEADING_ID,
        level: "2",
        size: "sm",
        css: {
          color: "$onSurfaceTextReversed",
          position: "absolute",
          insetInlineStart: "50%",
          transform: "translateX(-50%)"
        }
      },
      title
    ),
    !hideEndChat && /* @__PURE__ */ React18.createElement(
      Button6,
      {
        css: __spreadValues({
          padding: "$half $one",
          marginInlineEnd: "$quarter"
        }, buttonFocusStyles),
        onClick: endChat,
        ref: endChatButtonRef
      },
      formatMessage({ id: "END_CHAT" })
    )
  );
}

// src/hooks/use-live-chat-machine.hook.ts
import { useActor } from "@xstate/react";
var useLiveChatMachine = () => useActor(getActor());

// src/components/end-chat-modal-content/end-chat-modal-content.component.tsx
import React19, { useEffect as useEffect4 } from "react";
import {
  Box as Box13,
  HeadingText as HeadingText5,
  Button as Button7,
  Modal as Modal3,
  HeadingBar,
  ParagraphText as ParagraphText7
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME7,
  PRODUCT_AREA as PRODUCT_AREA7,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA7,
  trackAnalyticsEvent as trackAnalyticsEvent7
} from "@leagueplatform/analytics";
function EndChatModalContent({
  onChatEnd,
  onCancel
}) {
  const { formatMessage } = useIntl11();
  useEffect4(() => {
    trackAnalyticsEvent7(EVENT_NAME7.SCREEN_LOADED, {
      product_area: PRODUCT_AREA7.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA7.LIVE_CHAT,
      screen_name: "end chat pop up"
    });
  }, []);
  return /* @__PURE__ */ React19.createElement(
    Modal3.Content,
    {
      onInteractOutside: onCancel,
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 384 },
      forceModalFocus: false
    },
    /* @__PURE__ */ React19.createElement(
      HeadingBar,
      {
        title: /* @__PURE__ */ React19.createElement(Modal3.Title, null, /* @__PURE__ */ React19.createElement(HeadingText5, { level: "5", size: "sm" }, formatMessage({ id: "END_CHAT" })))
      }
    ),
    /* @__PURE__ */ React19.createElement(
      Box13,
      {
        css: {
          padding: "$threeQuarters $one"
        }
      },
      /* @__PURE__ */ React19.createElement(Modal3.Description, null, /* @__PURE__ */ React19.createElement(
        ParagraphText7,
        {
          emphasis: "subtle",
          size: "sm",
          css: { textAlign: "center" }
        },
        formatMessage({ id: "END_CHAT_MODAL_DESCRIPTION" })
      )),
      /* @__PURE__ */ React19.createElement(Modal3.Close, null, /* @__PURE__ */ React19.createElement(
        Button7,
        {
          destructive: true,
          width: "fillContainer",
          css: { marginTop: "$oneAndHalf" },
          onClick: onChatEnd
        },
        formatMessage({ id: "END_CHAT" })
      )),
      /* @__PURE__ */ React19.createElement(Modal3.Close, null, /* @__PURE__ */ React19.createElement(
        Button7,
        {
          width: "fillContainer",
          quiet: true,
          priority: "secondary",
          css: { marginTop: "$half" },
          onClick: onCancel
        },
        formatMessage({ id: "RETURN_TO_CHAT" })
      ))
    )
  );
}

// src/hooks/use-live-chat-end-chat.hook.ts
import { useState as useState3 } from "react";
import { useNavigateLegacy as useNavigate3 } from "@leagueplatform/routing";
var useLiveChatEndChat = () => {
  const [showEndChatModal, setShowEndChatModal] = useState3(false);
  const navigate = useNavigate3();
  const onConfirmNavigation = () => {
    setShowEndChatModal(false);
    navigate(-1);
  };
  const onCancelNavigation = () => {
    setShowEndChatModal(false);
  };
  return {
    showEndChatModal,
    setShowEndChatModal,
    onCancelNavigation,
    onConfirmNavigation
  };
};

// src/components/live-chat/live-chat.component.tsx
var Wrapper = styled4(Box14, {
  backgroundColor: "$surfaceBackgroundTertiary",
  display: "flex",
  justifyContent: "center",
  inset: 0,
  position: "absolute",
  overflow: "hidden"
});
var MessageWindow = styled4(Box14, {
  backgroundColor: "$surfaceBackgroundPrimary",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: "668px"
});
var ErrorWrapper = styled4(Box14, {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  padding: "0 $five",
  "@mobile": {
    padding: "0 $one"
  }
});
var UIEvents = [
  "Message" /* MESSAGE */,
  "ParticipantJoined" /* PARTICIPANT_JOINED */,
  "ParticipantLeft" /* PARTICIPANT_LEFT */
];
var Loading = () => /* @__PURE__ */ React20.createElement(
  Box14,
  {
    css: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      color: "$decorativeBrandPrimaryDefault"
    }
  },
  /* @__PURE__ */ React20.createElement(Spinner, { loading: true })
);
var LiveChat = () => {
  var _a, _b, _c;
  const navigate = useNavigate4();
  const { formatMessage } = useIntl12();
  const title = formatMessage({ id: "CHAT" });
  const { shouldShowNavigateAway } = useLiveChatConfig();
  const { data: userProfileData } = useGetUserProfile();
  const userName = `${((_a = userProfileData == null ? void 0 : userProfileData.userProfile) == null ? void 0 : _a.preferredFirstName) || ((_b = userProfileData == null ? void 0 : userProfileData.userProfile) == null ? void 0 : _b.firstName) || ""} ${((_c = userProfileData == null ? void 0 : userProfileData.userProfile) == null ? void 0 : _c.lastName) || ""}`;
  const userId = (userProfileData == null ? void 0 : userProfileData.userId) || "";
  const endChatButtonRef = React20.useRef(null);
  const [liveChatCurrent, sendLiveChatEvent] = useLiveChatMachine();
  const { context: liveChatContext } = liveChatCurrent;
  const {
    chatEndedReason,
    queueTitle,
    queueDescription,
    toastErrors,
    chips,
    events,
    failedMessagesEventIds,
    isConnectingToAgentWhileChatActive,
    isAgentTyping
  } = liveChatContext;
  const chatEnded = liveChatCurrent.matches("chatInactive");
  const isChatUnavailable = chatEndedReason.type === "CHAT_UNAVAILABLE" /* CHAT_UNAVAILABLE */;
  const [endChatButtonHasFocus, setEndChatButtonHasFocus] = React20.useState(false);
  const queueData = {
    isQueued: liveChatCurrent.matches("chatQueued"),
    queueTitle,
    queueDescription
  };
  const chatLoading = liveChatCurrent.matches("idle") || liveChatCurrent.matches("connecting");
  const chatEvents = events.filter((event) => UIEvents.includes(event.type));
  const {
    showEndChatModal,
    setShowEndChatModal,
    onCancelNavigation,
    onConfirmNavigation
  } = useLiveChatEndChat();
  const sendEndChatEvent = () => {
    sendUserEvent({
      type: "EndChat" /* END_CHAT */,
      eventId: uuidv44()
    });
    if (!shouldShowNavigateAway) {
      onConfirmNavigation();
    }
    trackAnalyticsEvent8(EVENT_NAME8.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA8.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA8.LIVE_CHAT,
      screen_name: "end chat pop up",
      detail: formatMessage({ id: "END_CHAT" })
    });
  };
  const closeUnavailableChat = () => {
    sendEndChatEvent();
    if (!shouldShowNavigateAway) {
      navigate(-1);
    }
  };
  React20.useEffect(() => {
    var _a2;
    if (endChatButtonHasFocus && !showEndChatModal) {
      (_a2 = endChatButtonRef.current) == null ? void 0 : _a2.focus();
    }
  }, [endChatButtonHasFocus, showEndChatModal]);
  const cancelNavigation = () => {
    onCancelNavigation();
    setEndChatButtonHasFocus(true);
    trackAnalyticsEvent8(EVENT_NAME8.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA8.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA8.LIVE_CHAT,
      screen_name: "end chat pop up",
      detail: formatMessage({ id: "RETURN_TO_CHAT" })
    });
  };
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, showEndChatModal && /* @__PURE__ */ React20.createElement(
    Modal4.Root,
    {
      defaultOpen: true,
      onOpenChange: () => setShowEndChatModal(!showEndChatModal)
    },
    /* @__PURE__ */ React20.createElement(
      EndChatModalContent,
      {
        onChatEnd: sendEndChatEvent,
        onCancel: cancelNavigation
      }
    )
  ), /* @__PURE__ */ React20.createElement(Wrapper, null, /* @__PURE__ */ React20.createElement(MessageWindow, null, shouldShowNavigateAway && /* @__PURE__ */ React20.createElement(
    ChatTopBar,
    {
      title,
      setShowEndChatModal,
      hideEndChat: isChatUnavailable,
      chatEnded,
      autofocus: chatLoading,
      endChatButtonRef,
      onMinimizeChat: () => {
        sendUserEvent({
          type: "SetVisibility" /* SET_VISIBILITY */,
          eventId: uuidv44(),
          visibility: "COLLAPSED" /* COLLAPSED */
        });
        trackAnalyticsEvent8(EVENT_NAME8.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA8.GET_CARE,
          sub_product_area: SUB_PRODUCT_AREA8.LIVE_CHAT,
          screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
          detail: "minimize chat"
        });
      }
    }
  ), chatLoading ? /* @__PURE__ */ React20.createElement(Loading, null) : /* @__PURE__ */ React20.createElement(React20.Fragment, null, !shouldShowNavigateAway && /* @__PURE__ */ React20.createElement(
    ChatHeader,
    {
      title,
      setShowEndChatModal,
      hideEndChat: isChatUnavailable,
      chatEnded
    }
  ), isChatUnavailable ? /* @__PURE__ */ React20.createElement(ErrorWrapper, null, /* @__PURE__ */ React20.createElement(
    ErrorState,
    {
      headingString: chatEndedReason.errorTitle || formatMessage({ id: "LIVE_CHAT_GENERIC_ERROR_TITLE" }),
      bodyString: chatEndedReason.errorMessage || formatMessage({
        id: "LIVE_CHAT_GENERIC_ERROR_DESCRIPTION"
      }),
      buttonText: formatMessage({
        id: "LIVE_CHAT_GENERIC_ERROR_BUTTON"
      }),
      onButtonClick: closeUnavailableChat,
      error: null
    }
  )) : /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(
    ChatMessagesGrid,
    __spreadValues({
      events: chatEvents,
      failedEvents: failedMessagesEventIds,
      userId,
      agentIsTyping: isAgentTyping,
      connectingToAnAgent: isConnectingToAgentWhileChatActive
    }, (queueData == null ? void 0 : queueData.isQueued) && { queueData })
  ), /* @__PURE__ */ React20.createElement(Box14, { "aria-live": "polite" }, toastErrors.length > 0 && /* @__PURE__ */ React20.createElement(
    LiveChatErrorToast,
    {
      toastErrors,
      clearToastError: (eventId) => sendLiveChatEvent({ type: "ClearError", eventId })
    }
  )), /* @__PURE__ */ React20.createElement(
    ChatForm,
    {
      userName,
      userId,
      chipsData: chips,
      chatEnded,
      inWaitingRoom: queueData == null ? void 0 : queueData.isQueued
    }
  ))))));
};

// src/components/live-chat-core/live-chat-core.component.tsx
var LiveChatCore = ({ startChatConfig }) => {
  const { shouldShowNavigateAway } = useLiveChatConfig();
  useEffect5(() => {
    if (!shouldShowNavigateAway) {
      sendUserEvent({
        config: startChatConfig || {},
        type: "StartChat" /* START_CHAT */,
        eventId: uuidv45()
      });
    }
  }, [startChatConfig, shouldShowNavigateAway]);
  return /* @__PURE__ */ React21.createElement(LiveChat, null);
};

// src/components/live-chat-container/live-chat-container.component.tsx
import {
  EVENT_NAME as EVENT_NAME9,
  PRODUCT_AREA as PRODUCT_AREA9,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA9,
  trackAnalyticsEvent as trackAnalyticsEvent9
} from "@leagueplatform/analytics";
function LiveChatContainer({
  mobileChatWindowVerticalOffset = "0px",
  layout,
  width,
  height,
  css
}) {
  const { liveChatState } = useLiveChatRepository();
  const isFirstChatVisit = React22.useRef(true);
  React22.useEffect(() => {
    if (liveChatState.visibility === "EXPANDED" /* EXPANDED */) {
      trackAnalyticsEvent9(EVENT_NAME9.SCREEN_LOADED, {
        product_area: PRODUCT_AREA9.GET_CARE,
        sub_product_area: SUB_PRODUCT_AREA9.LIVE_CHAT,
        screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
        first_time_entering_chat: isFirstChatVisit.current
      });
      isFirstChatVisit.current = false;
    }
  }, [liveChatState.visibility]);
  return /* @__PURE__ */ React22.createElement(
    ChatContainer,
    {
      isOpen: liveChatState.visibility === "EXPANDED" /* EXPANDED */,
      mobileChatWindowVerticalOffset,
      layout,
      width,
      height,
      css,
      onOpenChange: () => {
        setChatVisibility(
          liveChatState.visibility === "EXPANDED" /* EXPANDED */ ? "COLLAPSED" /* COLLAPSED */ : "EXPANDED" /* EXPANDED */
        );
      }
    },
    /* @__PURE__ */ React22.createElement(LiveChatCore, null)
  );
}

// src/live-chat.routes.tsx
import React24 from "react";
import { Routes, Route } from "@leagueplatform/routing";

// src/pages/live-chat-landing.page.tsx
import React23, { useEffect as useEffect7, useState as useState4 } from "react";
import { v4 as uuidv46 } from "uuid";
import { Box as Box15, Spinner as Spinner2 } from "@leagueplatform/genesis-core";
import { ErrorState as ErrorState2 } from "@leagueplatform/web-common-components";
import { useGoBack as useGoBack2, useDocumentTitle } from "@leagueplatform/web-common";

// src/hooks/use-get-first-questionnaire-id-config.hook.ts
var useGetFirstQuestionnaireIdConfig = () => useGetLiveChatConfig({
  select: (data) => data.data.find(
    (config) => {
      var _a;
      return ((_a = config == null ? void 0 : config.attributes) == null ? void 0 : _a.name) === "FIRST_QUESTIONNAIRE_ID";
    }
  )
});

// src/hooks/use-live-chat-landing.hook.ts
import { postStartChat } from "@leagueplatform/live-chat-api";
import { useMutation } from "@tanstack/react-query";
var useLiveChatLanding = () => {
  var _a, _b, _c;
  const {
    data: firstQuestionnaireId,
    isLoading: firstQuestionnaireLoading,
    isError: firstQuestionnaireError,
    isSuccess: firstQuestionnaireSuccess,
    error: firstQuestionnaireErrorType
  } = useGetFirstQuestionnaireIdConfig();
  const {
    data,
    mutate: postStartChatMutation,
    isLoading: postStartChatLoading,
    isError: postStartChatError,
    isSuccess: postStartChatSuccess,
    error: postStartChatErrorType
  } = useMutation(
    (answers) => postStartChat(answers)
  );
  return {
    firstQuestionnaireId,
    firstQuestionnaireSuccess,
    postStartChatMutation,
    postStartChatResponse: (_c = (_b = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.attributes) == null ? void 0 : _b.configs) != null ? _c : {},
    postStartChatSuccess,
    isLoading: firstQuestionnaireLoading || postStartChatLoading,
    isError: firstQuestionnaireError || postStartChatError,
    errors: [firstQuestionnaireErrorType, postStartChatErrorType]
  };
};

// src/pages/live-chat-landing.page.tsx
import { QuestionnaireFlow } from "@leagueplatform/fhir-questionnaire-flow";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME10,
  PRODUCT_AREA as PRODUCT_AREA10,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA10,
  trackAnalyticsEvent as trackAnalyticsEvent10
} from "@leagueplatform/analytics";

// src/pages/hooks/useRedirectToPreviousPage.hook.ts
import { useEffect as useEffect6, useRef as useRef4 } from "react";
import { useGoBack } from "@leagueplatform/web-common";
var useRedirectToPreviousPage = () => {
  const { shouldShowNavigateAway } = useLiveChatConfig();
  const { liveChatState } = useLiveChatRepository();
  const goBack = useGoBack();
  const hasRedirectedToPreviousPage = useRef4(false);
  useEffect6(() => {
    if (shouldShowNavigateAway && liveChatState.chatSessionState !== "NotStarted" && !hasRedirectedToPreviousPage.current) {
      if (liveChatState.visibility === "COLLAPSED" /* COLLAPSED */) {
        setChatVisibility("EXPANDED" /* EXPANDED */);
      }
      goBack();
      hasRedirectedToPreviousPage.current = true;
    }
  }, [
    goBack,
    liveChatState.chatSessionState,
    shouldShowNavigateAway,
    liveChatState.visibility
  ]);
};

// src/pages/live-chat-landing.page.tsx
var LiveChatLanding = () => {
  const { formatMessage } = useIntl13();
  const [isQuestionnaireDone, setIsQuestionnaireDone] = useState4(false);
  const { shouldShowNavigateAway } = useLiveChatConfig();
  const { liveChatState, sendUserEvent: sendUserEvent2 } = useLiveChatRepository();
  const goBack = useGoBack2();
  const questionnaireTitle = formatMessage({
    id: "LIVE_CHAT_LANDING_PAGE_TITLE"
  });
  useDocumentTitle(formatMessage({ id: "LIVE_CHAT_LANDING_PAGE_TITLE" }));
  useEffect7(() => {
    trackAnalyticsEvent10(EVENT_NAME10.SCREEN_LOADED, {
      product_area: PRODUCT_AREA10.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA10.LIVE_CHAT,
      screen_name: questionnaireTitle
    });
  }, [questionnaireTitle]);
  const {
    firstQuestionnaireId,
    firstQuestionnaireSuccess,
    postStartChatMutation,
    postStartChatResponse,
    postStartChatSuccess,
    isLoading,
    isError,
    errors
  } = useLiveChatLanding();
  const hasCompletedQuestionnaire = firstQuestionnaireId && isQuestionnaireDone && postStartChatSuccess;
  const hasNoQuestionnaireConfigured = firstQuestionnaireSuccess && !firstQuestionnaireId;
  useEffect7(() => {
    if (hasNoQuestionnaireConfigured) {
      postStartChatMutation([]);
    }
  }, [hasNoQuestionnaireConfigured, postStartChatMutation]);
  useEffect7(() => {
    const gatedHasCompletedQuestionnaire = shouldShowNavigateAway && hasCompletedQuestionnaire;
    const gatedHasNoQuestionnaireConfigured = shouldShowNavigateAway && hasNoQuestionnaireConfigured;
    if (gatedHasCompletedQuestionnaire || gatedHasNoQuestionnaireConfigured && postStartChatSuccess) {
      if (liveChatState.chatSessionState === "NotStarted") {
        sendUserEvent2({
          config: postStartChatResponse || {},
          type: "StartChat" /* START_CHAT */,
          eventId: uuidv46()
        });
      }
    }
  }, [
    hasCompletedQuestionnaire,
    hasNoQuestionnaireConfigured,
    liveChatState.chatSessionState,
    sendUserEvent2,
    shouldShowNavigateAway,
    postStartChatResponse,
    postStartChatSuccess
  ]);
  useRedirectToPreviousPage();
  const handleClose = (title) => {
    trackAnalyticsEvent10(EVENT_NAME10.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA10.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA10.LIVE_CHAT,
      screen_name: title,
      detail: "exit questionnaire"
    });
    goBack();
  };
  const handleCompleted = (thread) => __async(void 0, null, function* () {
    var _a;
    const answers = (_a = thread.answers) != null ? _a : [];
    yield postStartChatMutation(answers);
    setIsQuestionnaireDone(true);
    trackAnalyticsEvent10(EVENT_NAME10.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA10.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA10.LIVE_CHAT,
      screen_name: questionnaireTitle,
      detail: formatMessage({ id: "QUESTIONNAIRE_FLOW_CONTINUE" })
    });
  });
  if (isLoading) {
    return /* @__PURE__ */ React23.createElement(
      Box15,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React23.createElement(Spinner2, { loading: true })
    );
  }
  if (isError) {
    return /* @__PURE__ */ React23.createElement(
      Box15,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React23.createElement(
        ErrorState2,
        {
          hideButton: true,
          headingString: formatMessage({ id: "GENERIC_MESSAGING_ERROR" }),
          error: errors
        }
      )
    );
  }
  return firstQuestionnaireId && !isQuestionnaireDone ? /* @__PURE__ */ React23.createElement(
    QuestionnaireFlow,
    {
      title: questionnaireTitle,
      firstQuestionnaireId: firstQuestionnaireId.attributes.value,
      onClose: handleClose,
      onCompleted: handleCompleted
    }
  ) : /* @__PURE__ */ React23.createElement(LiveChatCore, { startChatConfig: postStartChatResponse });
};

// src/live-chat.routes.tsx
var LiveChatRoutes = () => /* @__PURE__ */ React24.createElement(Routes, null, /* @__PURE__ */ React24.createElement(Route, { element: /* @__PURE__ */ React24.createElement(LiveChatLanding, null), path: "/*" }));

// src/index.ts
initModule();
export {
  ChatEndedReasonTypes,
  ErrorTypes,
  EventTypes,
  LiveChatContainer,
  LiveChatRoutes,
  VisibilityState,
  liveChatRepository,
  setChatVisibility,
  useLiveChatCta,
  useLiveChatRepository
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/live-chat'] = window.leagueSDKsPresent['@leagueplatform/live-chat'] || [];
    window.leagueSDKsPresent['@leagueplatform/live-chat'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/live-chat'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/live-chat module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map